import api from '../api';
const baseUrl = process.env.REACT_APP_AUTH_API_URL;

const getWorkspaceByProjectId = async (projectId, keycloakToken) => {
    try {
        const response = await api.get(`${baseUrl}/workspace`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
            params: {
                projectId: projectId
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error at getting workspace items by project id:", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar itens do workspace.");
    }
}

const deleteWorkspaceItem = async (workspaceItemId, keycloakToken) => {
    try {
        const response = await api.delete(`${baseUrl}/workspace/${workspaceItemId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error at deleting workspace item:", error);
        throw new Error(error?.response?.data?.message || "Erro ao deletar item do workspace.");
    }
}

export default { getWorkspaceByProjectId, deleteWorkspaceItem };